import { render, staticRenderFns } from "./off.vue?vue&type=template&id=1d0dd428&"
import script from "./off.vue?vue&type=script&lang=ts&"
export * from "./off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports